import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from './supabase';

function IncomingCall({ invite, onDismiss }) {
  var navigate = useNavigate();
  var [avatar, setAvatar] = useState(null);
  var [nickname, setNickname] = useState('\u6797\u664F');
  var [showDeclineOptions, setShowDeclineOptions] = useState(false);
  var ringRef = useRef(null);

  // 来电铃声：WebAudio合成的双音嘟嘟声，能响则响（原生壳/已解锁的PWA），被autoplay政策拦住就静默降级
  useEffect(function() {
    var ctx = null, stopped = false, timers = [];
    try {
      var AC = window.AudioContext || window.webkitAudioContext;
      if (AC) {
        ctx = new AC();
        var ringOnce = function() {
          if (stopped || !ctx || ctx.state === 'closed') return;
          try {
            [0, 0.55].forEach(function(offset) {
              var osc = ctx.createOscillator();
              var gain = ctx.createGain();
              osc.type = 'sine';
              osc.frequency.value = 880;
              var t = ctx.currentTime + offset;
              gain.gain.setValueAtTime(0, t);
              gain.gain.linearRampToValueAtTime(0.18, t + 0.04);
              gain.gain.setValueAtTime(0.18, t + 0.32);
              gain.gain.linearRampToValueAtTime(0, t + 0.4);
              osc.connect(gain); gain.connect(ctx.destination);
              osc.start(t); osc.stop(t + 0.45);
            });
          } catch(e) {}
        };
        if (ctx.state === 'suspended') { ctx.resume().catch(function() {}); }
        ringOnce();
        var iv = setInterval(ringOnce, 2600);
        timers.push(iv);
        ringRef.current = { ctx: ctx, timers: timers };
      }
    } catch(e) {}
    return function() {
      stopped = true;
      timers.forEach(function(t) { clearInterval(t); });
      if (ctx) { try { ctx.close(); } catch(e) {} }
    };
  }, []);

  useEffect(function() {
    async function loadProfile() {
      var { data } = await supabase.from('profile_settings').select('*');
      if (data) {
        data.forEach(function(p) {
          if (p.key === 'avatar_him' && p.value) setAvatar(p.value);
          if (p.key === 'nickname_him' && p.value) setNickname(p.value);
        });
      }
    }
    loadProfile();
  }, []);

  var accept = async function() {
    try {
      await fetch('/api/call/answer', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: invite.id, action: 'accept' })
      });
    } catch(e) {}
    onDismiss();
    navigate('/call', { state: { invite: invite } });
  };

  var decline = async function(note) {
    try {
      await fetch('/api/call/answer', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: invite.id, action: 'decline', note: note || '' })
      });
    } catch(e) {}
    onDismiss();
  };

  var quickReplies = [
    { text: '\u5FD9', label: '\u5FD9' },
    { text: '\u5728\u5916\u9762', label: '\u5728\u5916\u9762' },
    { text: '\u53D1\u6D88\u606F\u5427', label: '\u53D1\u6D88\u606F\u5427' }
  ];

  if (!invite) return null;

  return (
    <div className="incoming-call-backdrop">
      <div className="incoming-call-card">
        <div className="ic-kind">
          <i className="ic-dot" />
          <span>{'\u6765\u7535'}</span>
        </div>
        <div className="ic-avatar-wrap">
          <div className="ic-avatar-glow" />
          {avatar
            ? <img className="ic-avatar-img" src={avatar} alt="" />
            : <div className="ic-avatar-text">{nickname.charAt(0)}</div>
          }
        </div>
        <div className="ic-name">{nickname}</div>
        <div className="ic-reason">{invite.reason || '\u60F3\u542C\u542C\u4F60\u7684\u58F0\u97F3'}</div>

        {!showDeclineOptions ? (
          <div className="ic-actions">
            <button className="ic-btn decline" onClick={function() { setShowDeclineOptions(true); }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6" transform="rotate(135 12 12)"/></svg>
            </button>
            <button className="ic-btn accept" onClick={accept}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
            </button>
          </div>
        ) : (
          <div className="ic-decline-options">
            {quickReplies.map(function(qr, i) {
              return (
                <button className="ic-quick-reply" key={i} onClick={function() { decline(qr.text); }}>
                  {qr.label}
                </button>
              );
            })}
            <button className="ic-quick-reply cancel" onClick={function() { setShowDeclineOptions(false); }}>
              {'\u8FD4\u56DE'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default IncomingCall;
